module.exports = __webpack_public_path__ + "static/media/tooltips_d_011.movie.59ff7891.mp4";